import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'PhdSoftPathValue'
})
export class PhdSoftPathValuePipe implements PipeTransform {

  transform(value: any, path: string): any {

    if (value && path) {
     return path.split('.').reduce((p, c) => {
        return p ? p[c] : null;
      }, value);
    }
    return null;
  }

}
